module.exports = __webpack_public_path__ + "img/victor-lawson.1cf62c38.png";